<script>
import ApiLaporan from "@/store/api/laporan";
import { onMounted, reactive, toRefs, onBeforeUnmount } from "vue";
import { isLoading } from "@/store/reactive.js";
import { useRoute, useRouter } from "vue-router";
import { getCurrentInstance } from "vue";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";

export default {
    name: "Laporan All",
    setup() {
        const app = getCurrentInstance();
        const globalProperties = app.appContext.config.globalProperties;

        const route = useRoute();
        const router = useRouter();
        GlobalWorkerOptions.workerSrc = "/js/pdf.worker.min.js";
        const state = reactive({
            datas: [],
            dataCategorys: [],
            form: {
                category: "",
            },
            page: 1,
            isNext: false,
            showPdfModal: false,
            selectedReport: null,
            pdfPages: [],
            pdfLoading: false,
            pdfError: false,
        });
        onMounted(async () => {
            if (route.query.category) {
                state.form.category = route.query.category;
            }
            await getData();
        });
        const getData = async () => {
            isLoading.value = true;
            try {
                const page = state.page;
                const formCategory = state.form.category;
                const { data, category, paginate } = await ApiLaporan.getAll(
                    page,
                    formCategory
                );
                state.datas = [...state.datas, ...data];
                state.dataCategorys = category;
                state.page = state.page + 1;
                state.isNext = paginate.isNext;
            } catch (error) {
                globalProperties.$wkToast(error, {
                    className: "wk-alert",
                });
            } finally {
                isLoading.value = false;
            }
        };
        const hendelLink = (data) => {
            if (data.link) {
                state.selectedReport = data;
                state.pdfPages = [];
                state.pdfError = false;
                state.showPdfModal = true;
                document.body.classList.add("overflow-hidden");
                loadPdf(data.link);
            } else if (data.in_link) {
                router.push(data.in_link);
            }
        };
        const loadPdf = async (url) => {
            state.pdfLoading = true;
            try {
                const pdf = await getDocument(url).promise;
                const pages = [];

                for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
                    const page = await pdf.getPage(pageNumber);
                    const viewport = page.getViewport({ scale: 1.35 });
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");

                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    await page.render({ canvasContext: context, viewport }).promise;
                    pages.push({ number: pageNumber, image: canvas.toDataURL("image/jpeg", 0.9) });
                }

                if (state.selectedReport && state.selectedReport.link === url) {
                    state.pdfPages = pages;
                }
            } catch (error) {
                console.error("Gagal memuat preview PDF", error);
                state.pdfError = true;
            } finally {
                state.pdfLoading = false;
            }
        };
        const closePdfModal = () => {
            state.showPdfModal = false;
            state.selectedReport = null;
            state.pdfPages = [];
            document.body.classList.remove("overflow-hidden");
        };
        const handleEscape = (event) => {
            if (event.key === "Escape" && state.showPdfModal) {
                closePdfModal();
            }
        };
        const hendelCategory = async () => {
            state.page = 1;
            state.datas = [];
            await getData();
        };
        const hendelNext = async () => {
            await getData();
        };
        onMounted(() => document.addEventListener("keydown", handleEscape));
        onBeforeUnmount(() => {
            document.removeEventListener("keydown", handleEscape);
            document.body.classList.remove("overflow-hidden");
        });
        return {
            ...toRefs(state),
            isLoading,
            hendelLink,
            hendelCategory,
            hendelNext,
            closePdfModal,
        };
    },
};
</script>
<template>
    <section class="text-gray-600 body-font overflow-hidden mx-20">
        <div class="container py-10">
            <div class="flex flex-col items-center justify-center gap-10">
                <div class="w-full">
                    <select
                        @change="hendelCategory"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        v-model="form.category"
                    >
                        <option value="">-- Pilih Kategory --</option>
                        <option
                            v-for="category in dataCategorys"
                            :key="category"
                            :value="category.id"
                        >
                            {{ category.name }}
                        </option>
                    </select>
                </div>
                <div class="w-full">
                    <div class="grid lg:grid-cols-4 gap-5">
                        <div
                            class="w-full"
                            v-for="(data, key) in datas"
                            :key="`dataLaporan${key}`"
                        >
                            <div class="max-w-sm mx-auto">
                                <div
                                    class="mb-6 max-w-max overflow-hidden rounded-xl h-64 w-full cursor-pointer"
                                    @click="hendelLink(data)"
                                >
                                    <img
                                        class="transform hover:scale-105 transition ease-in-out duration-1000"
                                        :src="data.image"
                                        alt=""
                                        data-config-id="auto-img-1-2"
                                    />
                                </div>
                                <h3
                                    class="text-xl font-bold font-heading leading-normal dark:text-slate-300"
                                    data-config-id="auto-txt-5-2"
                                >
                                    {{ data.name }}
                                </h3>
                                <button
                                    type="button"
                                    class="mt-3 rounded-lg bg-blue-600 px-4 py-2 text-sm text-white transition hover:bg-blue-700"
                                    @click="hendelLink(data)"
                                >
                                    Lihat PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex flex-start justify-center">
                    <div>
                        <button
                            v-if="isNext && !isLoading"
                            @click="hendelNext"
                            class="bg-blue-600 text-white py-2 px-5 rounded-lg"
                        >
                            Selanjutnya
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="showPdfModal && selectedReport"
            class="modal modal-full pdf-preview-modal"
            role="dialog"
            aria-modal="true"
            :aria-label="`Preview ${selectedReport.name}`"
            @click.self="closePdfModal"
        >
            <div class="modal-dialog pdf-preview-dialog">
                <div class="modal-content pdf-preview-content">
                    <div class="pdf-preview-header">
                        <div>
                            <p class="pdf-preview-eyebrow">Preview dokumen</p>
                            <h2 class="pdf-preview-title">
                            {{ selectedReport.name }}
                            </h2>
                        </div>
                        <div class="pdf-preview-actions">
                            <a
                                :href="selectedReport.link"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="pdf-preview-open"
                            >
                                Buka di tab baru
                            </a>
                            <button
                                type="button"
                                class="pdf-preview-close"
                                aria-label="Tutup preview PDF"
                                @click="closePdfModal"
                            >
                                &times;
                            </button>
                        </div>
                    </div>
                    <div class="pdf-preview-body">
                        <div v-if="pdfLoading" class="pdf-preview-state">
                            <div class="pdf-spinner"></div>
                            <p>Memuat preview PDF...</p>
                        </div>
                        <div v-else-if="pdfError" class="pdf-preview-state">
                            <p>Preview PDF tidak dapat dimuat.</p>
                            <a :href="selectedReport.link" target="_blank" rel="noopener noreferrer" class="pdf-preview-open">
                                Buka dokumen
                            </a>
                        </div>
                        <div v-else class="pdf-pages">
                            <div v-for="page in pdfPages" :key="page.number" class="pdf-page">
                                <img :src="page.image" :alt="`Halaman ${page.number}`" />
                                <span>Halaman {{ page.number }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.pdf-preview-modal {
    position: fixed !important;
    inset: 0 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 100vw !important;
    height: 100vh !important;
    padding: 0 !important;
    overflow: hidden !important;
    z-index: 9999 !important;
    background: rgba(15, 23, 42, 0.78) !important;
}

.pdf-preview-dialog {
    width: min(94vw, 1180px) !important;
    height: min(92vh, 900px) !important;
    margin: 0 !important;
    padding: 0 !important;
}

.pdf-preview-content {
    display: flex !important;
    height: 100% !important;
    border: 0 !important;
    border-radius: 14px !important;
    overflow: hidden !important;
    background: #f1f5f9 !important;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
}

.pdf-preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1.25rem;
    color: #e2e8f0;
    background: #172554;
}

.pdf-preview-eyebrow {
    margin: 0 0 0.2rem;
    color: #93c5fd;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.pdf-preview-title {
    margin: 0;
    color: #fff;
    font-size: 1.05rem;
    font-weight: 700;
}

.pdf-preview-actions {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.pdf-preview-open,
.pdf-preview-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
    text-decoration: none;
}

.pdf-preview-open {
    padding: 0.6rem 0.85rem;
    color: #172554;
    background: #bfdbfe;
}

.pdf-preview-open:hover {
    background: #dbeafe;
}

.pdf-preview-close {
    width: 2.2rem;
    height: 2.2rem;
    color: #fff;
    background: rgba(255, 255, 255, 0.14);
    font-size: 1.5rem;
    line-height: 1;
}

.pdf-preview-close:hover {
    background: rgba(255, 255, 255, 0.25);
}

.pdf-preview-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    height: auto !important;
    overflow: auto !important;
    padding: 1.25rem !important;
    background: #cbd5e1;
}

.pdf-pages {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
}

.pdf-page {
    position: relative;
    width: min(100%, 820px);
    padding: 0.5rem;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.2);
}

.pdf-page img {
    display: block;
    width: 100%;
    height: auto;
}

.pdf-page span {
    display: block;
    padding-top: 0.35rem;
    color: #64748b;
    font-size: 0.75rem;
    text-align: center;
}

.pdf-preview-state {
    display: flex;
    min-height: 240px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    color: #475569;
}

.pdf-spinner {
    width: 2rem;
    height: 2rem;
    border: 3px solid #cbd5e1;
    border-top-color: #2563eb;
    border-radius: 9999px;
    animation: pdf-spin 0.8s linear infinite;
}

@keyframes pdf-spin {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 640px) {
    .pdf-preview-dialog {
        width: 100vw !important;
        height: 100vh !important;
    }

    .pdf-preview-content {
        border-radius: 0 !important;
    }

    .pdf-preview-header {
        padding: 0.85rem;
    }

    .pdf-preview-title {
        max-width: 45vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .pdf-preview-open {
        padding: 0.55rem;
        font-size: 0;
    }

    .pdf-preview-open::after {
        content: "↗";
        font-size: 1rem;
    }
}
</style>
